var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIconDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Settings",
    transform: "translate(-0.061 0.121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 28,
    height: 28,
    rx: 14,
    transform: "translate(0.061 -0.121)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fi-rr-pencil",
    d: "M11.946.642a1.9,1.9,0,0,0-2.679,0l-8.5,8.5A2.6,2.6,0,0,0,0,10.992v1.073a.523.523,0,0,0,.523.523H1.6a2.6,2.6,0,0,0,1.848-.765l8.5-8.5a1.9,1.9,0,0,0,0-2.678ZM2.7,11.083a1.58,1.58,0,0,1-1.109.459h-.55v-.55A1.558,1.558,0,0,1,1.5,9.883L7.957,3.431l1.2,1.2Zm8.5-8.5L9.9,3.891l-1.2-1.2L10,1.381a.849.849,0,0,1,1.2,1.2Z",
    transform: "translate(7.964 7.388)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconDark);
export default __webpack_public_path__ + "static/media/edit-icon-dark.9db4a967749d865f3ab94c073bff38d1.svg";
export { ForwardRef as ReactComponent };